import type { Variants as TagVariants } from '@ds/components/Tag/Tag.constant'

import { ROUTE_NAMES } from '~/constants/routes'

import { STEP_STATUS } from '../../../../Home.constants'

export const STEP_STATUS_VARIANT: Record<string, TagVariants> = {
  [STEP_STATUS.TO_DO]: 'warning',
  [STEP_STATUS.COMPLETED]: 'success',
  [STEP_STATUS.IN_REVIEW]: 'info',
  [STEP_STATUS.NOT_VERIFIED]: 'danger',
}

// TODO update/remove this mapping after updating backend
export const ONBOARDING_ROUTE_NAMES_MAPPING: Record<string, string> = {
  bo_merchant_onboarding: ROUTE_NAMES.ONBOARDING.INDEX,
  bo_merchant_onboarding_home: ROUTE_NAMES.ONBOARDING.HOME,
  onboarding_listing_create_product_duplicate:
    ROUTE_NAMES.ONBOARDING.LISTINGS.CREATE.PRODUCT.DUPLICATE,
  onboarding_listings_create_product_search:
    ROUTE_NAMES.ONBOARDING.LISTINGS.CREATE.PRODUCT.SEARCH,
  onboarding_listings_create_details:
    ROUTE_NAMES.ONBOARDING.LISTINGS.CREATE.DETAILS,
  onboarding_listings_active: ROUTE_NAMES.ONBOARDING.LISTINGS.TABS.ACTIVE,
  onboarding_listings_missing_infos:
    ROUTE_NAMES.ONBOARDING.LISTINGS.TABS.MISSING_INFOS,
  onboarding_listings_in_validation:
    ROUTE_NAMES.ONBOARDING.LISTINGS.TABS.IN_VALIDATION,
  onboarding_listings_archived: ROUTE_NAMES.ONBOARDING.LISTINGS.TABS.ARCHIVED,
  onboarding_bo_options_addresses: ROUTE_NAMES.ONBOARDING.OPTIONS.ADDRESSES,
  onboarding_bo_options_address_book:
    ROUTE_NAMES.ONBOARDING.OPTIONS.ADDRESS_BOOK,
  onboarding_bo_options_buyback: ROUTE_NAMES.ONBOARDING.OPTIONS.BUYBACK,
  onboarding_bo_options: ROUTE_NAMES.ONBOARDING.OPTIONS.INDEX,
  onboarding_bo_options_integrations:
    ROUTE_NAMES.ONBOARDING.OPTIONS.INTEGRATIONS,
  onboarding_bo_options_kyb: ROUTE_NAMES.ONBOARDING.OPTIONS.HYPERWALLET.KYB,
  onboarding_bo_options_my_info: ROUTE_NAMES.ONBOARDING.OPTIONS.MY_INFO,
  onboarding_bo_options_payment: ROUTE_NAMES.ONBOARDING.OPTIONS.PAYMENT,
  onboarding_bo_options_pricing: ROUTE_NAMES.ONBOARDING.OPTIONS.PRICING,
  onboarding_bo_options_services: ROUTE_NAMES.ONBOARDING.OPTIONS.SERVICES,
  onboarding_bo_options_shipping: ROUTE_NAMES.ONBOARDING.OPTIONS.SHIPPING,
  onboarding_bo_options_transfer_methods:
    ROUTE_NAMES.ONBOARDING.OPTIONS.HYPERWALLET.TRANSFER_METHODS,
  onboarding_bo_options_transfer_methods_confirmation:
    ROUTE_NAMES.ONBOARDING.OPTIONS.TRANSFER_METHODS_CONFIRMATION,
  onboarding_merchant_profile_root: ROUTE_NAMES.ONBOARDING.PROFILE.INDEX,
  onboarding_merchant_profile_home: ROUTE_NAMES.ONBOARDING.PROFILE.HOME,
  onboarding_merchant_profile_legal_details:
    ROUTE_NAMES.ONBOARDING.PROFILE.LEGAL_DETAILS,
  onboarding_merchant_profile_company_info:
    ROUTE_NAMES.ONBOARDING.PROFILE.COMPANY_INFO,
  onboarding_merchant_profile_contact_details:
    ROUTE_NAMES.ONBOARDING.PROFILE.CONTACT_DETAILS,
  onboarding_merchant_profile_user_permissions:
    ROUTE_NAMES.ONBOARDING.PROFILE.USER_PERMISSIONS,
  onboarding_feedback_page: ROUTE_NAMES.ONBOARDING.FEEDBACK,
  docusign_cgu: ROUTE_NAMES.DOCUSIGN_CGU,
}
